import axios from "../utils/http";

const dashboard = {
  brief() {
    return axios.post("dashboard/brief");
  },
};

export default dashboard;
